import { render, staticRenderFns } from "./salesOrderList.vue?vue&type=template&id=6b90eb44&scoped=true&"
import script from "./salesOrderList.vue?vue&type=script&lang=js&"
export * from "./salesOrderList.vue?vue&type=script&lang=js&"
import style0 from "./salesOrderList.vue?vue&type=style&index=0&id=6b90eb44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b90eb44",
  null
  
)

export default component.exports